module.exports = __webpack_public_path__ + "static/assets/dfa003f3cdb9e992b58b1079a5b0c675.png";